import { objectsToArray } from './objects-to-array';

export function objectsToString(
  object: Record<string, string> | undefined,
): string {
  return objectsToArray(object).join(' ');
}
